import React, { PropsWithChildren } from 'react';

import { ConfigurationsData } from '../../config';
import { useSelectorConfigValue } from '../configuration.selectors';

type Props<T extends keyof ConfigurationsData> = PropsWithChildren<{
    configKey: T
}>;

export function FeatureSwitch<T extends keyof ConfigurationsData> ({
    configKey, children
}: Props<T>) {
    const isEnabled = useSelectorConfigValue(configKey) === 'true';

    return isEnabled
        ? <>{children}</>
        : null;
}
